exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LittleActivityCreation[data-v-abd4b23e]{padding:20px}.card[data-v-abd4b23e]{width:100%;border-bottom:1px solid #e0e0e0}.select_block[data-v-abd4b23e]{width:4px;height:20px;background:#4d8aff;margin-right:4px}.block[data-v-abd4b23e]{width:2px;height:20px;background:#e0e0e0;margin-right:4px}.select_title[data-v-abd4b23e]{color:#000;font-weight:600;font-size:18px}.title[data-v-abd4b23e]{color:#b4acac;font-size:18px}.add_btn[data-v-abd4b23e]{background:#4d8aff;border-radius:4px;padding:2px 10px;font-size:18px;color:#fff;margin-bottom:4px;margin-right:20px}", ""]);

// exports
